import startCase from 'lodash/startCase';
import type { ReactElement } from 'react';

import { Grid, Heading, Text } from '@simplywallst/ui-core';

import { pluralise } from '@/utilities/pluralise';

import RootTooltip from '@/components/Tooltip';

import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

interface Props {
  portfolio: Portfolio | null;
  section: 'value' | 'future' | 'past' | 'health' | 'dividend';
  children: ReactElement;
}

export const Tooltip = ({ portfolio, section, children }: Props) => (
  <RootTooltip
    title={
      <Grid
        minWidth={260}
        templateColumns="auto max-content"
        alignItems="center"
        justifyContent="space-between"
        data-cy-id="snowflake-tooltip"
      >
        <div>
          <Heading as="h3" typography="smallStrong">
            Average {startCase(section)} Score
          </Heading>
          {portfolio ? (
            <Text typography="tiny" color="whiteRGBA" opacity={0.5}>{`${
              portfolio.holdings.length
            } ${pluralise(
              portfolio.holdings.length,
              'holding',
              'holdings'
            )}`}</Text>
          ) : null}
        </div>
        <Text typography="smallStrong" color="whiteRGBA" opacity={0.5}>
          <Text
            as="span"
            typography="megaStrong"
            color="white"
            data-cy-id="score"
          >
            {portfolio ? portfolio.snowflake.scores[section] || 0 : 0}
          </Text>
          {` `}/ 6
        </Text>
      </Grid>
    }
    placement="top"
  >
    <g>{children}</g>
  </RootTooltip>
);
